export default __webpack_public_path__ + "static/media/checklist-primary.b952ad73.svg";